// PixInvoiceModal stub - Payment integrations discontinued
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface PixInvoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  invoice: any;
}

export function PixInvoiceModal({ isOpen, onClose }: PixInvoiceModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Pagar com PIX</DialogTitle>
        </DialogHeader>
        <p className="text-muted-foreground">
          A funcionalidade de pagamento PIX foi descontinuada.
        </p>
      </DialogContent>
    </Dialog>
  );
}

export default PixInvoiceModal;
